import Navbar from "./components/Navbar";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import LoadingOverlay from "./components/LoadingOverlay";
import { Outlet } from "react-router-dom";

export default function AppLayout({ token, setToken }) {
    return (
        <div className="flex flex-col" style={{ height: '100dvh' }}> 
          <Navbar token={token} setToken={setToken} />
          <LoadingOverlay />
          <main className="flex-1 overflow-y-auto"
                  style={{
                    paddingBottom: "calc(var(--safe-area-inset-bottom))", // safe area
                  }}
          >
            <Outlet />
          </main>
          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      );
}